import { render, staticRenderFns } from "./BlockTabs.vue?vue&type=template&id=20397db9&"
import script from "./BlockTabs.vue?vue&type=script&lang=js&"
export * from "./BlockTabs.vue?vue&type=script&lang=js&"
import style0 from "./BlockTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports